import {login, logout} from '@/api/sys/authentication/login'
import {Message} from 'element-ui'
import {setToken, removeToken} from '@/utils/auth'
import {setCookie, removeCookie} from '@/utils/cookie'
import Common from '@/utils/common'
var publicUrl = ''//'http://47.93.91.218:8083'
function findInListByFunctionNo(list, functionNo) {
  for (let i = 0; i < list.length; i++) {
    if (list[i].functionNo === functionNo) {
      return list[i]
    }
  }
}

function findFirstInList(list) {
  for (let i = 0; i < list.length; i++) {
    if (list[i].path) {
      return list[i]
    } else {
      if (list[i].children) {
        for (let j = 0; j < list[i].children.length; j++) {
          if (list[i].children[j].path) {
            return list[i].children[j]
          }
        }
      }
    }
  }
}

//加载外部css文件
function loadCss(style) {
  let ele = document.createElement("style");
  ele.setAttribute("id", "buttonPermission");
  ele.innerHTML = style;
  document.getElementsByTagName('head')[0].appendChild(ele)
}

export default {
  state: {
    token: undefined,
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    }
  },
  getters: {
    token: state => state.token,
  },
  actions: {
    // user login
    login({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        Common.httpPost("登录", publicUrl+'/portal/login/login/login', userInfo, false, true).then(res => {
          if (res.menus.length > 0) {
            let home = findInListByFunctionNo(res.menus, 'enterpriseHome');
            if (!home) {
              home = findInListByFunctionNo(res.menus, 'platformHome');
              if (!home) {
                home = findFirstInList(res.menus);
              }
            }
            commit('INIT_MENU', res.menus);
            setCookie('index', home.path);
          } else {
            Message({
              message: "当前登录用户没有配置角色功能",
              type: 'error',
              duration: 5 * 1000
            });
          }
          // 加载按钮权限控制css文件
          loadCss(res.style);
          setCookie('userStatus', res.userStatus);
          setToken(res.token);
          commit('SET_TOKEN', res.token);
          //将左侧的标题放cookie中
          setCookie('leftTitle', res.leftTitle);
          resolve()
        })
      })
    },

    // user logout
    logout({commit}) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', undefined);
        removeToken();
        removeCookie('index');
        removeCookie('setTimeOut');
        removeCookie('userStatus');
        removeCookie('leftTitle');
        removeToken('userStatus');

        let buttonPermission = document.getElementById("buttonPermission");
        if (buttonPermission) {
          buttonPermission.remove();
        }
        window.location.href = "/static/login.html";
        resolve()
      })
    },

    // get user info
    getUserInfo({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        Common.httpPost("获取用户信息", publicUrl+'/portal/login/login/getUserInfo').then(res => {
          if (res.menus.length > 0) {
            let home = findInListByFunctionNo(res.menus, 'enterpriseHome');
            if (!home) {
              home = findInListByFunctionNo(res.menus, 'platformHome');
              if (!home) {
                home = findFirstInList(res.menus);
              }
            }
            commit('INIT_MENU', res.menus);
            setCookie('index', home.path);
          } else {
            Message({
              message: "当前登录用户没有配置角色功能",
              type: 'error',
              duration: 5 * 1000
            });
          }
          // 加载按钮权限控制css文件
          loadCss(res.style);
          setCookie('userStatus', res.userStatus);
          setToken(res.token);
          commit('SET_TOKEN', res.token);
          //将左侧的标题放cookie中
          setCookie('leftTitle', res.leftTitle);
          resolve()
        })
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/user.js